import { render } from "./SectionPrices.vue?vue&type=template&id=4601eb40&scoped=true"
const script = {}

import "./SectionPrices.vue?vue&type=style&index=0&id=4601eb40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4601eb40"]])

export default __exports__